interface SourcesTabProps {
  evidenceIds: string[]
}

export function SourcesTab({ evidenceIds }: SourcesTabProps) {
  if (evidenceIds.length === 0)
    return <p className="text-harbor-text-muted">No sources recorded.</p>
  return (
    <ul className="space-y-2">
      {evidenceIds.map((id) => (
        <li
          key={id}
          className="rounded-lg border border-harbor-border bg-harbor-surface-raised p-3 font-mono text-xs text-harbor-text-secondary"
        >
          {id}
        </li>
      ))}
    </ul>
  )
}
